
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const SingleItem = ({ singleItem, correctAnswer }) => {

    const click = () => {
        if(singleItem === correctAnswer){
            toast.success(' Wow This is the correct Answer!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
        }
        else{
            toast.warn(' Wrong Answer!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                });
        }
        
    }


    return (

        <div className='bg-teal-100 p-5 rounded-lg m-2 text-center'>

            <button> <input type="radio" name="singleItem" value={singleItem} onClick={click} /> {singleItem}</button>
            <ToastContainer></ToastContainer>
           

        </div>

    );
};

export default SingleItem;